import { render, staticRenderFns } from "./ShopeeDataTable.vue?vue&type=template&id=0f9af662&scoped=true&"
import script from "./ShopeeDataTable.vue?vue&type=script&lang=js&"
export * from "./ShopeeDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9af662",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBadge,VBtn,VPagination,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9af662')) {
      api.createRecord('0f9af662', component.options)
    } else {
      api.reload('0f9af662', component.options)
    }
    module.hot.accept("./ShopeeDataTable.vue?vue&type=template&id=0f9af662&scoped=true&", function () {
      api.rerender('0f9af662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Connector/components/Shopee/ShopeeDataTable.vue"
export default component.exports